<template>
  <div class="page" :class="{'page__has-bar': !readonly}">
    <div class="page__bd">
      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__hd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">科目编号</label>
            <em class="weui-form-preview__value">{{form.ca_code}}</em>
          </div>
        </div>
        <div class="weui-form-preview__bd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">科目类别</label>
            <em class="weui-form-preview__value">{{form.ca_class}}</em>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">余额方向</label>
            <span class="weui-form-preview__value">{{form.ca_balancetype}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">科目描述</label>
            <span class="weui-form-preview__value">{{form.ca_desc}}</span>
          </div>
          <div class="weui-form-preview__item" v-if="form.ca_pcode">
            <label class="weui-form-preview__label">上级科目</label>
            <span class="weui-form-preview__value">{{form.ca_pcode}}&nbsp;{{form.ca_pname}}</span>
          </div>
          <div class="weui-form-preview__item" v-if="form.ca_ass">
            <label class="weui-form-preview__label">辅助核算</label>
            <span class="weui-form-preview__value">{{assDisplay}}</span>
          </div>
          <div class="weui-form-preview__item" v-if="form.ca_currency">
            <label class="weui-form-preview__label">外币核算</label>
            <span class="weui-form-preview__value">{{currencyDisplay}}</span>
          </div>
          <div class="weui-form-preview__item" v-if="form.ca_israteadj">
            <label class="weui-form-preview__label">期末调汇</label>
            <span class="weui-form-preview__value">是</span>
          </div>
          <div class="weui-form-preview__item" v-if="form.ca_iscash">
            <label class="weui-form-preview__label">现金及现金等价物</label>
            <span class="weui-form-preview__value">是</span>
          </div>
          <div class="weui-form-preview__item" v-if="form.ca_bank">
            <label class="weui-form-preview__label">开户银行</label>
            <span class="weui-form-preview__value">{{form.ca_bank}}</span>
          </div>
          <div class="weui-form-preview__item" v-if="form.ca_bankaccount">
            <label class="weui-form-preview__label">银行账号</label>
            <span class="weui-form-preview__value">{{form.ca_bankaccount}}</span>
          </div>
          <div class="weui-form-preview__item" v-if="form.ca_isdefaultaccount">
            <label class="weui-form-preview__label">默认收付款账户</label>
            <span class="weui-form-preview__value">是</span>
          </div>
          <div class="weui-form-preview__item" v-if="form.ca_cashname">
            <label class="weui-form-preview__label">现金流量项</label>
            <span class="weui-form-preview__value">{{form.ca_cashname}}</span>
          </div>
        </div>

        <a
          href="javascript:"
          @click="addChild"
          class="weui-cell weui-cell_active weui-cell_access weui-cell_link"
        >
          <div class="weui-cell__bd">新增下级科目</div>
          <span class="weui-cell__ft"></span>
        </a>
      </div>
    </div>

    <div class="footer-bar weui-dialog__ft" v-if="!readonly">
      <router-link
        :to="'/finance/category_edit?id='+form.id"
        class="weui-dialog__btn weui-dialog__btn_primary"
      >编辑</router-link>
      <a
        href="javascript:;"
        v-if="form.ca_statuscode=='AUDITED'"
        class="weui-dialog__btn weui-dialog__btn_primary"
        @click="enable(0)"
      >禁用</a>
      <a
        href="javascript:;"
        v-if="form.ca_statuscode!='AUDITED'"
        class="weui-dialog__btn weui-dialog__btn_default"
        @click="enable(1)"
      >启用</a>
      <a
        href="javascript:;"
        class="weui-dialog__btn weui-dialog__btn_default"
        @click="f_remove(null,form.id)"
      >删除</a>
    </div>
  </div>
</template>

<script>
import form from "@/mixins/form.js";

export default {
  mixins: [form],
  data() {
    return {
      baseUrl: "/api/finance/category"
    };
  },
  computed: {
    assDisplay() {
      var me = this,
        ass = me.form.ca_ass;
      if (ass) {
        var types = {
          Cust: "客户",
          Vend: "供应商",
          Dept: "部门",
          Empl: "员工",
          Project: "项目"
        };
        return ass
          .split(",")
          .map(name => {
            return types[name];
          })
          .join(" ");
      }
      return null;
    },
    currencyDisplay() {
      var me = this,
        ca_currency = me.form.ca_currency;
      if (ca_currency == "ALL") {
        return "核算所有外币";
      }
      return ca_currency;
    }
  },
  methods: {
    addChild() {
      var me = this,
        main = me.form;
      me.$router.push({
        name: "FinanceCategoryEdit",
        params: {
          parent: Object.assign({}, main)
        }
      });
    },
    /**
     * 禁用/启用
     * 因为url比较特殊，不能使用标准f_enable
     */
    enable(enabled) {
      var me = this,
        id = me.form.id;
      me.$loading({
        url: me.baseUrl + "/" + (enabled ? "enable" : "disable") + "/" + id,
        method: "POST"
      })
        .then(function(res) {
          if (res.success) {
            me.$weui.toast((enabled ? "启用" : "禁用") + "成功", 2000);
            window.location.reload();
          } else {
            me.$weui.topTips("操作失败: " + res.message, 3000);
          }
        })
        .catch(function() {
          me.$weui.topTips("操作失败", 3000);
        });
    }
  }
};
</script>